<!-- The template is now non-recursive and much simpler. -->
<div class="json-viewer-container">
  <!--
    Loop over the pre-processed 'displayLines' array.
    Each item in this array represents one visible line in the output.
  -->
  <div *ngFor="let line of displayLines"
       class="line"
       [style.padding-left.px]="line.depth * 20">

    <!-- Case 1: The line is a standard key-value pair. -->
    <ng-container *ngIf="line.type === 'keyValue'">
      <span class="key">{{ line.key }}:</span>
      <!-- If the value is a primitive (not an object), display it. -->
      <ng-container *ngIf="!line.isObject">
        <span class="value-primitive">
          {{ line.value }}
        </span>
      </ng-container>
    </ng-container>

    <!-- Case 2: The line is the ellipsis, indicating truncation. -->
    <ng-container *ngIf="line.type === 'ellipsis'">
      <span class="key">...</span>
    </ng-container>

  </div>
</div>
